import React from 'react'
import './BurgerMenuPopup.css'
import { Link, useLocation } from 'react-router-dom'
import {CurrentUserContext} from '../../../contexts/CurrentUserContext'
import {LanguageContext} from '../../../contexts/TranslationContext'
import choose from '../../../const/HeaderLan'

function BurgerMenuPopup({onClose, isOpen, isLoggin, getUnreadbleMessages, unreadbleMessages, onAdPopup}) {
    const currentUser = React.useContext(CurrentUserContext)

    const userId = currentUser.user_id
    
    const location = useLocation();
    
    const { language, changeLanguage } = React.useContext(LanguageContext)

    const { en, rus, hebrew } = choose;

    let translatedContext = '';
      if (language === 'en') {
        translatedContext = en;
      } else if (language === 'rus') {
        translatedContext = rus;
      } else if (language === 'hebrew') {
        translatedContext = hebrew;
    }

    const handleLanguageChange = (newLanguage) => {
        changeLanguage(newLanguage);
    };

    function handleGetUnreadbleMessages() {
        getUnreadbleMessages(userId)
        onClose()
    }

    function handleAddAdClick() {
        onClose()
        getUnreadbleMessages(userId)
        onAdPopup()
    }

return (
    
  <div className={`burgerMenuPopup ${isOpen && 'burgerMenuPopup__opened'}`}>
    <div className="burgerMenuPopup__container">
        <button 
            className="burgerMenuPopup__close-btn" 
            type="button" 
            onClick={onClose}>
        </button>

      {isLoggin ?
        <div className='burgerMenuPopup_wrapper'>

          <Link to={`/`} className='burgerMenuPopup_link' onClick={handleGetUnreadbleMessages}>
            <div className='burgerMenuPopup_add-main-page-pic'></div>
            <button className='burgerMenuPopup_add-announcement-btn font'>{translatedContext.mainPage}</button>
          </Link>

          <div className='burgerMenuPopup_add-announcement-container'>
            <div className='burgerMenuPopup_add-announcement-btn-pic' onClick={handleAddAdClick}></div>
            <button className='burgerMenuPopup_add-announcement-btn font' onClick={handleAddAdClick}>{translatedContext.addNewAddBtnName}</button>
          </div> 

          <Link to={`/users/${userId}`} className='burgerMenuPopup_link' onClick={handleGetUnreadbleMessages}>
            <div className='burgerMenuPopup_add-mypage-pic'></div>
            <button className='burgerMenuPopup_add-announcement-btn font'>{translatedContext.mypage}</button>
          </Link>

          <Link  to={`/my_favorites`} className='burgerMenuPopup_link' onClick={handleGetUnreadbleMessages}>
            <button className='burgerMenuPopup_favorite-btn'></button>
            <button className='burgerMenuPopup_add-announcement-btn font'>{translatedContext.favoritesBtn}</button>
          </Link>

          <Link to={`/users/${userId}/messages`} className='burgerMenuPopup_link burgerMenuPopup_link-message-container' onClick={onClose}>
            <button className='burgerMenuPopup__message-pic'></button>
            {unreadbleMessages.length > 0? 
                <div className='burgerMenuPopup__messages-badge'>{unreadbleMessages.length}</div>
                :
                <></>
            }     
            <button className='burgerMenuPopup_add-announcement-btn font'>{translatedContext.myMessagesBtn}</button>
          </Link>

          <div className='header__lang-container burgerMenuPopup_link'>
            <button onClick={() => handleLanguageChange('rus')} className={language === 'rus'? 'header__lang-btn_active font':'header__lang-btn font'}>RU</button>
            <button onClick={() => handleLanguageChange('en')} className={language === 'en'? 'header__lang-btn_active font':'header__lang-btn font'}>EN</button>
            <button onClick={() => handleLanguageChange('hebrew')} className={language === 'hebrew'? 'header__lang-btn_active font':'header__lang-btn font'}>HE</button>
          </div>
        </div>
      :  
      isLoggin ?
      <div className='column'>
        <div className='burgerMenuPopup_wrapper'>
          <Link to={`/users/`} className='burgerMenuPopup_login-link' onClick={handleGetUnreadbleMessages}>
            <p className='burgerMenuPopup_login-link font'>{translatedContext.mypage}</p>
          </Link>
        </div>
        <div className='header__lang-container burgerMenuPopup_link'>
            <button onClick={() => handleLanguageChange('rus')} className={language === 'rus'? 'header__lang-btn_active font':'header__lang-btn font'}>RU</button>
            <button onClick={() => handleLanguageChange('en')} className={language === 'en'? 'header__lang-btn_active font':'header__lang-btn font'}>EN</button>
            <button onClick={() => handleLanguageChange('hebrew')} className={language === 'hebrew'? 'header__lang-btn_active font':'header__lang-btn font'}>HE</button>
        </div>
      </div>
         
      :
      !isLoggin  && location.pathname === '/signup-first-stage'?
      <div className='column'>
        <Link to="/signin" className='burgerMenuPopup_login-link font' onClick={onClose}>
          <p>{translatedContext.login}</p>
        </Link>
        <div className='header__lang-container burgerMenuPopup_link'>
          <button onClick={() => handleLanguageChange('rus')} className={language === 'rus'? 'header__lang-btn_active font':'header__lang-btn font'}>RU</button>
          <button onClick={() => handleLanguageChange('en')} className={language === 'en'? 'header__lang-btn_active font':'header__lang-btn font'}>EN</button>
          <button onClick={() => handleLanguageChange('hebrew')} className={language === 'hebrew'? 'header__lang-btn_active font':'header__lang-btn font'}>HE</button>
        </div>
      </div>
      :
      !isLoggin && location.pathname === '/signin'?
      <div className='column'>
        <Link to="/signup-first-stage" className='burgerMenuPopup_registraion-link font' onClick={onClose}>
          <p>{translatedContext.registraion}</p>
        </Link>
        <div className='header__lang-container burgerMenuPopup_link'>
          <button onClick={() => handleLanguageChange('rus')} className={language === 'rus'? 'header__lang-btn_active font':'header__lang-btn font'}>RU</button>
          <button onClick={() => handleLanguageChange('en')} className={language === 'en'? 'header__lang-btn_active font':'header__lang-btn font'}>EN</button>
          <button onClick={() => handleLanguageChange('hebrew')} className={language === 'hebrew'? 'header__lang-btn_active font':'header__lang-btn font'}>HE</button>
        </div>
      </div>

      :
      <div className='burgerMenuPopup__links-container'>
        <div className='column'>
          <Link to="/signin" className='burgerMenuPopup_registraion-link font' onClick={onClose}>
            <p>{translatedContext.login}</p>
          </Link>
          <Link to="/signup-first-stage" className='burgerMenuPopup_registraion-link font' onClick={onClose}>
            <p>{translatedContext.registraion}</p>
          </Link>

          <div className='header__lang-container burgerMenuPopup_link'>
            <button onClick={() => handleLanguageChange('rus')} className={language === 'rus'? 'header__lang-btn_active font':'header__lang-btn font'}>RU</button>
            <button onClick={() => handleLanguageChange('en')} className={language === 'en'? 'header__lang-btn_active font':'header__lang-btn font'}>EN</button>
            <button onClick={() => handleLanguageChange('hebrew')} className={language === 'hebrew'? 'header__lang-btn_active font':'header__lang-btn font'}>HE</button>
          </div>
        </div>
      </div>
      }
    </div>
    
  </div>
)
}

export default  BurgerMenuPopup;